'use client';

import cx from 'classnames';
import { useAtomValue } from 'jotai';

import TermListItem from '../TermListItem';
import { filteredGlossaryTermsAtom } from '../jotai';
import styles from './index.module.scss';

const TermList = ({ className }: { className?: string }) => {
  const filteredGlossaryTerms = useAtomValue(filteredGlossaryTermsAtom);
  return (
    <ul className={cx(styles.list, className)}>
      {filteredGlossaryTerms.map((glossaryTerm) => (
        <li key={glossaryTerm.sys.id} className={styles.item}>
          <TermListItem glossaryTerm={glossaryTerm} />
        </li>
      ))}
    </ul>
  );
};

export default TermList;
